export const string = (value) => {
    return typeof value === 'string';
};
